import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const intigriti = defineConnector({
  identifier: "intigriti",
  name: "Intigriti",
  tagLine: "Bug bounty and vulnerability disclosure",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.intigriti\\.com/external/company/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create an Intigriti API application",
      items: [
        {
          kind: "markdown",
          content:
            "As a Company Admin, open **Admin → Integrations → Intigriti API**, create an API token, select read access, set its lifetime, and register the redirect URI below. Activate it and save the OAuth client credentials. See [API setup](https://kb.intigriti.com/en/articles/6117846-intigriti-api).",
        },
      ],
    },
    {
      title: "Configure your application",
      items: [
        {
          kind: "markdown",
          content:
            "Copy and paste the following redirect URI into your Intigriti application settings:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/intigriti/callback",
        },
      ],
    },
    {
      title: "Enter your client credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client Secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Define scopes for this connection",
      items: [
        {
          kind: "markdown",
          content:
            "Add [scopes](https://api.intigriti.com/external/company/swagger/v2.0/swagger.json) in a comma-separated list below.",
        },
        {
          kind: "input",
          label: "Scopes",
          placeholder: "company_external_api,core_platform:read,offline_access",
          required: true,
          defaultValue:
            "company_external_api,core_platform:read,offline_access",
          helperText: "Comma-separated list of desired scopes.",
          target: { kind: "oauthConnection", field: "scopes" },
        },
      ],
    },
    {
      title: "Authorize your Intigriti account",
      items: [
        {
          kind: "markdown",
          content:
            "Finally, authorize your Intigriti account to complete the connection.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
            { kind: "oauthConnection", field: "scopes" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () =>
      "https://login.intigriti.com/connect/authorize",
    tokenEndpoint: () => "https://login.intigriti.com/connect/token",
    tokenEndpointAuthMethod: () => "client_secret_basic",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.intigriti.com/external/company/v2/groups",
  },
});
